<template>
  <div class="scrap-car-modern">
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <div class="container">
        <el-breadcrumb class="breadcrumb">
          <el-breadcrumb-item
            ><span class="breadcrumb_span" @click="backHome"
              >政务服务</span
            ></el-breadcrumb-item
          >
          <el-breadcrumb-item>报废汽车</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 class="hero-title">报废汽车回收服务</h1>
        <p class="hero-subtitle">环保拆解 · 规范流程 · 政府补贴</p>
        <div class="hero-stats">
          <div class="stat-item" v-for="stat in heroStats" :key="stat.id">
            <div class="stat-value">{{ stat.value }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 主要内容区 -->
      <div class="content-layout">
        <!-- 左侧主内容 -->
        <div class="main-content">
          <!-- 流程卡片 -->
          <el-card shadow="never" class="process-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-s-operation"></i>
              </div>
              <h2>报废回收流程</h2>
              <el-tag type="success" effect="plain">5个步骤</el-tag>
            </div>

            <div class="process-steps">
              <div
                class="process-step"
                v-for="(step, index) in processSteps"
                :key="index"
                :style="{ '--step-color': step.color }"
              >
                <div class="step-number">{{ index + 1 }}</div>
                <div class="step-content">
                  <div class="step-header">
                    <h3>{{ step.title }}</h3>
                    <el-tag v-if="step.time" size="small">{{
                      step.time
                    }}</el-tag>
                  </div>
                  <p>{{ step.description }}</p>
                  <ul class="step-details" v-if="step.details">
                    <li v-for="(detail, i) in step.details" :key="i">
                      <i class="el-icon-check"></i> {{ detail }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 补贴政策 -->
          <el-card shadow="never" class="subsidy-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-s-finance"></i>
              </div>
              <h2>补贴政策</h2>
              <el-tag type="warning" effect="plain">政府支持</el-tag>
            </div>

            <div class="subsidy-grid">
              <div
                class="subsidy-item"
                v-for="item in subsidyItems"
                :key="item.type"
                :style="{ '--item-color': item.color }"
              >
                <div class="subsidy-type">{{ item.type }}</div>
                <div class="subsidy-amount">{{ item.amount }}</div>
                <div class="subsidy-condition">{{ item.condition }}</div>
              </div>
            </div>

            <div class="subsidy-tip">
              <i class="el-icon-info"></i>
              补贴金额会根据政策调整，具体以最新政策为准
            </div>
          </el-card>

          <!-- 申请表单 -->
          <el-card shadow="never" class="form-card glassmorph" v-if="showForm">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-edit"></i>
              </div>
              <h2>报废申请</h2>
            </div>

            <el-form
              :model="form"
              :rules="rules"
              ref="formRef"
              label-position="top"
              class="scrap-form"
            >
              <el-row :gutter="20">
                <el-col :md="12" :sm="24">
                  <el-form-item label="车主姓名" prop="ownerName">
                    <el-input
                      v-model="form.ownerName"
                      placeholder="请输入车主姓名"
                      prefix-icon="el-icon-user"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :md="12" :sm="24">
                  <el-form-item label="身份证号" prop="idCard">
                    <el-input
                      v-model="form.idCard"
                      placeholder="请输入身份证号码"
                      prefix-icon="el-icon-postcard"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :md="12" :sm="24">
                  <el-form-item label="联系电话" prop="phone">
                    <el-input
                      v-model="form.phone"
                      placeholder="请输入联系电话"
                      prefix-icon="el-icon-phone"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :md="12" :sm="24">
                  <el-form-item label="车辆类型" prop="carType">
                    <el-select
                      v-model="form.carType"
                      placeholder="请选择车辆类型"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in carTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :md="12" :sm="24">
                  <el-form-item label="车牌号码" prop="plateNumber">
                    <el-input
                      v-model="form.plateNumber"
                      placeholder="请输入车牌号码"
                      prefix-icon="el-icon-truck"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :md="12" :sm="24">
                  <el-form-item label="注册日期" prop="registerDate">
                    <el-date-picker
                      v-model="form.registerDate"
                      type="date"
                      placeholder="选择注册日期"
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="回收方式" prop="recycleMethod">
                <el-radio-group v-model="form.recycleMethod">
                  <el-radio-button label="self">自行送交</el-radio-button>
                  <el-radio-button label="pickup">上门回收</el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="选择回收点"
                prop="recycleLocation"
                v-if="form.recycleMethod === 'self'"
              >
                <el-select
                  v-model="form.recycleLocation"
                  placeholder="请选择回收点"
                  style="width: 100%"
                >
                  <el-option
                    v-for="loc in recycleLocations"
                    :key="loc.id"
                    :label="loc.name"
                    :value="loc.id"
                  >
                    <div class="location-option">
                      <span>{{ loc.name }}</span>
                      <span class="location-address">{{ loc.address }}</span>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="预约时间"
                prop="appointmentTime"
                v-if="form.recycleMethod === 'pickup'"
              >
                <el-date-picker
                  v-model="form.appointmentTime"
                  type="datetime"
                  placeholder="选择预约时间"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="车辆照片" prop="images">
                <el-upload
                  action="#"
                  list-type="picture-card"
                  :auto-upload="false"
                  :on-change="handleImageChange"
                  :file-list="form.images"
                  :limit="5"
                  multiple
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="upload-tip">
                  请上传车辆正面、侧面、后面及仪表盘照片（最多5张）
                </div>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  size="large"
                  @click="submitForm"
                  class="submit-btn"
                >
                  <i class="el-icon-s-claim"></i> 提交申请
                </el-button>
                <el-button size="large" @click="resetForm"> 重置 </el-button>
              </el-form-item>
            </el-form>
          </el-card>

          <!-- 申请按钮 -->
          <div class="action-buttons" v-if="!showForm">
            <el-button
              type="primary"
              size="large"
              @click="showForm = true"
              class="apply-btn"
            >
              <i class="el-icon-edit"></i> 立即申请报废
            </el-button>
            <el-button size="large" @click="downloadGuide" class="download-btn">
              <i class="el-icon-download"></i> 下载申请指南
            </el-button>
          </div>
        </div>

        <!-- 右侧边栏 -->
        <div class="sidebar">
          <!-- 回收网点 -->
          <el-card shadow="never" class="location-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-location-information"></i>
              </div>
              <h2>回收网点</h2>
              <el-tag type="info" effect="plain"
                >{{ recycleLocations.length }}个网点</el-tag
              >
            </div>

            <el-input
              v-model="locationQuery"
              placeholder="搜索回收点"
              class="location-search"
              prefix-icon="el-icon-search"
            >
            </el-input>

            <div class="location-list">
              <div
                class="location-item"
                v-for="loc in filteredLocations"
                :key="loc.id"
              >
                <div class="location-info">
                  <h3>{{ loc.name }}</h3>
                  <p><i class="el-icon-location"></i> {{ loc.address }}</p>
                  <p><i class="el-icon-phone"></i> {{ loc.phone }}</p>
                  <p><i class="el-icon-time"></i> {{ loc.businessHours }}</p>
                </div>
                <el-button type="text" @click="viewOnMap(loc)" class="map-btn">
                  <i class="el-icon-map-location"></i> 查看地图
                </el-button>
              </div>
            </div>
          </el-card>

          <!-- 常见问题 -->
          <el-card shadow="never" class="faq-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-question"></i>
              </div>
              <h2>常见问题</h2>
            </div>

            <el-collapse accordion>
              <el-collapse-item
                v-for="(faq, index) in faqs"
                :key="index"
                :title="faq.question"
                :name="index"
              >
                <div class="faq-answer" v-html="faq.answer"></div>
              </el-collapse-item>
            </el-collapse>
          </el-card>

          <!-- 相关服务 -->
          <el-card shadow="never" class="related-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-connection"></i>
              </div>
              <h2>相关服务</h2>
            </div>

            <div class="service-list">
              <div
                class="service-item"
                v-for="service in relatedServices"
                :key="service.id"
                @click="$router.push(service.path)"
              >
                <div
                  class="service-icon"
                  :style="{ backgroundColor: service.color }"
                >
                  <i :class="service.icon"></i>
                </div>
                <div class="service-content">
                  <h3>{{ service.title }}</h3>
                  <p>{{ service.desc }}</p>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollTop } from '@/util/scrollTop';
export default {
  name: 'ScrapCarModern',
  data() {
    return {
      showForm: false,
      locationQuery: '',
      heroStats: [
        { id: 1, value: '¥1200-2000', label: '平均补贴金额' },
        { id: 2, value: '7-15天', label: '平均处理周期' },
        { id: 3, value: '98%', label: '用户满意度' },
      ],
      processSteps: [
        {
          title: '提交申请',
          description: '填写车辆信息并提交申请',
          time: '1-3个工作日',
          color: '#409EFF',
          details: ['在线填写申请表', '上传车辆证件照片', '选择回收方式'],
        },
        {
          title: '审核确认',
          description: '工作人员审核申请材料',
          time: '1-2个工作日',
          color: '#67C23A',
          details: ['验证车辆信息', '确认回收资格', '通知审核结果'],
        },
        {
          title: '车辆交接',
          description: '将车辆移交至指定回收点',
          time: '按预约时间',
          color: '#E6A23C',
          details: ['自行送交或上门回收', '现场验车确认', '签署交接文件'],
        },
        {
          title: '拆解处理',
          description: '专业拆解并分类处理',
          time: '3-5个工作日',
          color: '#F56C6C',
          details: ['环保合规拆解', '分类处理零部件', '生成处理证明'],
        },
        {
          title: '完成注销',
          description: '办理车辆注销手续',
          time: '1-2个工作日',
          color: '#9966CC',
          details: ['自动提交注销申请', '发放注销证明', '补贴发放(如适用)'],
        },
      ],
      subsidyItems: [
        {
          type: '小型载客汽车',
          amount: '¥800-1200',
          condition: '使用10年以上',
          color: '#409EFF',
        },
        {
          type: '中型载客汽车',
          amount: '¥1000-1500',
          condition: '使用10年以上',
          color: '#67C23A',
        },
        {
          type: '大型载客汽车',
          amount: '¥1500-2000',
          condition: '使用10年以上',
          color: '#E6A23C',
        },
        {
          type: '微型货车',
          amount: '¥600-1000',
          condition: '使用8年以上',
          color: '#F56C6C',
        },
        {
          type: '轻型货车',
          amount: '¥800-1200',
          condition: '使用8年以上',
          color: '#9966CC',
        },
        {
          type: '新能源汽车',
          amount: '额外¥300-500',
          condition: '使用5年以上',
          color: '#909399',
        },
      ],
      carTypes: [
        { value: 'small_passenger', label: '小型载客汽车' },
        { value: 'medium_passenger', label: '中型载客汽车' },
        { value: 'large_passenger', label: '大型载客汽车' },
        { value: 'mini_truck', label: '微型货车' },
        { value: 'light_truck', label: '轻型货车' },
        { value: 'new_energy', label: '新能源汽车' },
      ],
      recycleLocations: [
        {
          id: 1,
          name: '城东环保回收中心',
          address: 'XX市城东区环保路88号',
          phone: '123-45678901',
          businessHours: '周一至周日 8:30-17:30',
          lat: 31.2304,
          lng: 121.4737,
        },
        {
          id: 2,
          name: '城南汽车拆解厂',
          address: 'XX市城南区工业园66号',
          phone: '123-45678902',
          businessHours: '周一至周六 9:00-17:00',
          lat: 31.2204,
          lng: 121.4837,
        },
        {
          id: 3,
          name: '城北资源再生站',
          address: 'XX市城北区绿园路33号',
          phone: '123-45678903',
          businessHours: '周一至周五 8:30-17:00',
          lat: 31.2404,
          lng: 121.4637,
        },
      ],
      form: {
        ownerName: '',
        idCard: '',
        phone: '',
        carType: '',
        plateNumber: '',
        registerDate: '',
        recycleMethod: 'self',
        recycleLocation: '',
        appointmentTime: '',
        images: [],
      },
      rules: {
        ownerName: [
          { required: true, message: '请输入车主姓名', trigger: 'blur' },
        ],
        idCard: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '身份证号码格式不正确',
            trigger: 'blur',
          },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur',
          },
        ],
        carType: [
          { required: true, message: '请选择车辆类型', trigger: 'change' },
        ],
        plateNumber: [
          { required: true, message: '请输入车牌号码', trigger: 'blur' },
        ],
        recycleLocation: [
          { required: true, message: '请选择回收地点', trigger: 'change' },
        ],
        appointmentTime: [
          { required: true, message: '请选择预约时间', trigger: 'change' },
        ],
      },
      faqs: [
        {
          question: '哪些车辆可以申请报废？',
          answer:
            '根据《报废机动车回收管理办法》，已注册登记的机动车达到国家规定的报废标准或虽未达到报废标准但发动机或者底盘严重损坏，经检验不符合国家机动车运行安全技术条件的，应当强制报废。',
        },
        {
          question: '报废车辆需要准备哪些材料？',
          answer:
            '1. 机动车登记证书<br>2. 机动车行驶证<br>3. 车主身份证明<br>4. 车辆号牌<br>5. 委托他人代办的还需提供代办人身份证明和授权委托书',
        },
        {
          question: '补贴金额如何计算？',
          answer:
            '补贴金额根据车辆类型、使用年限、排放标准等因素综合确定，具体标准可查询最新补贴政策。新能源汽车的补贴标准通常高于传统燃油车。',
        },
        {
          question: '整个报废流程需要多长时间？',
          answer:
            '从提交申请到完成注销通常需要7-15个工作日，具体时间取决于回收方式和车辆情况。',
        },
      ],
      relatedServices: [
        {
          id: 1,
          title: '补贴申领',
          desc: '查询和申请回收补贴',
          icon: 'el-icon-shopping-bag-2',
          path: '/subsidy',
          color: '#409EFF',
        },
        {
          id: 2,
          title: '以旧换新',
          desc: '汽车以旧换新政策',
          icon: 'el-icon-refresh',
          path: '/trade-in',
          color: '#67C23A',
        },
        {
          id: 3,
          title: '政策查询',
          desc: '最新报废回收政策',
          icon: 'el-icon-notebook-2',
          path: '/policy',
          color: '#E6A23C',
        },
      ],
    };
  },
  mounted() {
    scrollTop();
  },
  computed: {
    filteredLocations() {
      if (!this.locationQuery) {
        return this.recycleLocations.slice(0, 3);
      }
      return this.recycleLocations.filter((loc) => {
        return (
          loc.name.includes(this.locationQuery) ||
          loc.address.includes(this.locationQuery)
        );
      });
    },
  },
  methods: {
    handleImageChange(file, fileList) {
      this.form.images = fileList;
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$message.success('申请提交成功！');
          this.showForm = false;
          // 这里可以添加API调用
        }
      });
    },
    resetForm() {
      this.$refs.formRef.resetFields();
      this.form.images = [];
    },
    downloadGuide() {
      this.$message.success('开始下载申请指南');
      // 这里可以添加下载逻辑
    },
    viewOnMap(location) {
      // 这里可以集成地图功能
      this.$message.info(`查看 ${location.name} 的地图位置`);
    },
    backHome() {
      this.$emit('goBack', '');
    },
  },
};
</script>

<style lang="less" scoped>
.scrap-car-modern {
  background-color: #f8fafc;
  min-height: 100vh;
  margin-bottom: 60px;
}

.container {
  max-width: 1200px;
  padding: 0 20px;
  margin: 0 auto 30px auto;
}
.hero-section {
  color: white;
  padding: 50px 0 50px;
  position: relative;
  margin-bottom: -40px;
  background: url('~@/assets/recycling/componyImages/baofeiqichehuishou.png')
    center;
  background-size: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(64, 158, 255, 0.8) 0%,
    rgba(103, 194, 58, 0.6) 100%
  );
  z-index: 0;
}

.hero-section > .container {
  position: relative;
  z-index: 1;
}
.breadcrumb_span {
  color: #000000;
  font-weight: 500;
  cursor: pointer;
}

.breadcrumb /deep/ .el-breadcrumb__item {
  color: rgba(255, 255, 255, 0.8);
}

.breadcrumb /deep/ .el-breadcrumb__item:last-child {
  color: white;
  font-weight: bold;
}

.breadcrumb /deep/ .el-breadcrumb__separator {
  color: rgba(255, 255, 255, 0.6);
}

.hero-title {
  font-size: 36px;
  font-weight: 600;
  margin: 20px 0 10px;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 18px;
  opacity: 0.9;
  margin: 0 0 30px;
  font-weight: 300;
}

.hero-stats {
  display: flex;
  gap: 30px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  line-height: 40px;
  margin-bottom: 8px;
  color: white;
}

.stat-label {
  font-size: 14px;
  opacity: 0.9;
}

/* 内容布局 */
.content-layout {
  display: flex;
  gap: 24px;
  position: relative;
  z-index: 1;
}

.main-content {
  flex: 1;
  min-width: 0;
}

.sidebar {
  width: 360px;
  flex-shrink: 0;
}

@media (max-width: 992px) {
  .content-layout {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
  }
}

/* 卡片设计 */
.glassmorph {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.glassmorph:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.el-card {
  border: none;
  border-radius: 12px;
}

.el-card /deep/ .el-card__body {
  padding: 24px;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 18px;
}

.card-header h2 {
  font-size: 20px;
  margin: 0;
  color: #333;
  flex: 1;
}

/* 流程步骤 */
.process-steps {
  display: grid;
  gap: 20px;
}

.process-step {
  display: flex;
  position: relative;
  padding-left: 56px;
}

.process-step::before {
  content: '';
  position: absolute;
  left: 28px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(
    to bottom,
    var(--step-color),
    rgba(var(--step-color), 0.3)
  );
  opacity: 0.3;
}

.process-step:last-child::before {
  display: none;
}

.step-number {
  position: absolute;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: white;
  border: 2px solid var(--step-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--step-color);
  z-index: 1;
  box-shadow: 0 4px 12px rgba(var(--step-color), 0.2);
}

.step-content {
  padding-bottom: 24px;
}

.step-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.step-header h3 {
  font-size: 16px;
  margin: 0 10px 0 0;
  font-weight: 600;
  color: var(--step-color);
}

.step-content p {
  font-size: 14px;
  margin: 0 0 8px;
  color: #666;
  line-height: 1.6;
}

.step-details {
  margin: 10px 0 0;
  padding-left: 20px;
  list-style: none;
}

.step-details li {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
  position: relative;
}

.step-details li i {
  position: absolute;
  left: -20px;
  color: var(--step-color);
}

/* 补贴政策 */
.subsidy-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.subsidy-item {
  padding: 16px;
  border-radius: 8px;
  background: rgba(var(--item-color), 0.1);
  border-left: 4px solid var(--item-color);
}

.subsidy-type {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: var(--item-color);
}

.subsidy-amount {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 4px;
}

.subsidy-condition {
  font-size: 12px;
  color: #666;
}

.subsidy-tip {
  margin-top: 20px;
  padding: 12px;
  background: rgba(64, 158, 255, 0.1);
  border-radius: 6px;
  color: #409eff;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.subsidy-tip i {
  margin-right: 8px;
  font-size: 16px;
}

/* 表单样式 */
.scrap-form /deep/ .el-form-item__label {
  font-weight: 500;
  color: #555;
  padding-bottom: 8px;
}

.scrap-form /deep/ .el-input__inner {
  height: 44px;
  border-radius: 8px;
}

.scrap-form /deep/ .el-radio-button__inner {
  border-radius: 8px !important;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.submit-btn {
  width: 180px;
  height: 44px;
  font-size: 16px;
  border-radius: 8px;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 16px;
  margin: 30px 0;
}

.apply-btn {
  padding: 0 30px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: linear-gradient(90deg, #409eff, #66b1ff);
  border: none;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.download-btn {
  padding: 0 30px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: white;
  border: 1px solid #dcdfe6;
}

/* 回收网点 */
.location-search {
  margin-bottom: 16px;
}

.location-search /deep/ .el-input__inner {
  border-radius: 20px;
  height: 40px;
}

.location-list {
  max-height: 400px;
  overflow-y: auto;
}

.location-item {
  display: flex;
  padding: 16px 0;
  border-bottom: 1px dashed #ebeef5;
}

.location-item:last-child {
  border-bottom: none;
}

.location-info {
  flex: 1;
}

.location-info h3 {
  font-size: 15px;
  margin: 0 0 8px;
  color: #333;
}

.location-info p {
  font-size: 13px;
  margin: 4px 0;
  color: #666;
  display: flex;
  align-items: center;
}

.location-info i {
  margin-right: 6px;
  color: #999;
}

.map-btn {
  align-self: center;
  color: #409eff;
}

/* 常见问题 */
.faq-card /deep/ .el-collapse-item__header {
  font-size: 15px;
  font-weight: 500;
  padding: 12px 0;
  border-bottom: 1px dashed #ebeef5;
}

.faq-card /deep/ .el-collapse-item__content {
  padding: 12px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.faq-answer {
  padding-right: 20px;
}

/* 相关服务 */
.service-list {
  display: grid;
  gap: 12px;
}

.service-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.service-item:hover {
  background: rgba(64, 158, 255, 0.05);
  transform: translateX(4px);
}

.service-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  margin-right: 12px;
}

.service-content {
  flex: 1;
}

.service-content h3 {
  font-size: 14px;
  margin: 0 0 4px;
  color: #333;
}

.service-content p {
  font-size: 12px;
  margin: 0;
  color: #999;
}

.service-item .el-icon-arrow-right {
  color: #999;
  margin-left: 10px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .hero-stats {
    flex-direction: column;
    gap: 20px;
  }

  .subsidy-grid {
    grid-template-columns: 1fr;
  }

  .action-buttons {
    flex-direction: column;
  }

  .apply-btn,
  .download-btn {
    width: 100%;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.process-card,
.subsidy-card,
.form-card,
.location-card,
.faq-card,
.related-card {
  animation: fadeInUp 0.6s ease-out forwards;
}

.process-card {
  animation-delay: 0.1s;
}
.subsidy-card {
  animation-delay: 0.2s;
}
.form-card {
  animation-delay: 0.3s;
}
.location-card {
  animation-delay: 0.4s;
}
.faq-card {
  animation-delay: 0.5s;
}
.related-card {
  animation-delay: 0.6s;
}
</style>
